import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/images/logobg.png'
import _imports_1 from '../assets/images/logo1.png'
import _imports_2 from '../assets/images/logo_main.png'


const _hoisted_1 = { class: "loginPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logobg" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Logezy Reference"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "login-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Sign in", -1)
const _hoisted_7 = {
  key: 0,
  class: "emailError"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Reference Unable to log in. Please be sure you log in with the email you used to register with Logezy.", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "user-action" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Forgot your password?", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Sign in ")
const _hoisted_14 = {
  key: 1,
  class: "form-divider"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "or", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "register" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Sign in using ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "divider",
  style: {"display":"none"}
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Sign Up ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " Enter your registered email address. We will send new password to your registered email address. ", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Request")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " Enter your email address and password from Logezy application. ", -1)
const _hoisted_26 = {
  key: 0,
  class: "emailError"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "Reference Unable to log in. Please be sure you log in with the email you used to register with Logezy.", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Find Agency")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Sign in")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 12,
          class: "left"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 12,
          class: "right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (_ctx.emailError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form, {
                  ref: "formRef",
                  model: _ctx.formState,
                  rules: _ctx.rules,
                  layout: "vertical",
                  onFinish: _ctx.login,
                  onFinishFailed: _ctx.handleFinishFailed
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      class: "username",
                      required: "",
                      name: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "Email",
                          value: _ctx.formState.email,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.email) = $event)),
                          type: "text",
                          size: "large",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_user_outlined, { type: "user" })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      class: "password",
                      required: "",
                      name: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formState.password,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event)),
                          size: "large",
                          placeholder: "Password",
                          type: "password",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_LockOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "forgot-password",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showForgotPopup && _ctx.showForgotPopup(...args)))
                      }, _hoisted_12)
                    ]),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          size: "large",
                          block: "",
                          class: "login-btn",
                          "html-type": "submit",
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules", "onFinish", "onFinishFailed"]),
                (_ctx.hideSignup)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    block: "",
                    class: "logezysignin",
                    style: {"display":"none"},
                    onClick: _ctx.showLogezySignInPopup
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18,
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _hoisted_20,
                  (_ctx.hideSignup)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        size: "large",
                        block: "",
                        class: "signup",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signUp()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "Forgot Password?",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      class: "forgotPoup"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          class: "calcel-button",
          onClick: _ctx.handleCancel
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          class: "request-button",
          loading: _ctx.confirmLoading,
          onClick: _ctx.sendPassword
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_22,
        _createVNode(_component_a_input, {
          value: _ctx.forgotPasswordEmail,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.forgotPasswordEmail) = $event)),
          type: "text",
          size: "large",
          placeholder: "Enter your email",
          "allow-clear": "",
          autocomplete: "off"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      title: "Sign in With Logezy",
      visible: _ctx.signInLogezy,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.signInLogezy) = $event)),
      class: "forgotPoup signLogezypop"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          class: "calcel-button",
          onClick: _ctx.handleCancel
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          class: "request-button",
          loading: _ctx.fetchLoading,
          onClick: _ctx.signinwithlogezy
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_25,
        _createVNode(_component_a_input, {
          placeholder: "Email",
          value: _ctx.logezyEmail,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.logezyEmail) = $event)),
          type: "text",
          size: "large",
          "allow-clear": "",
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [
            _createVNode(_component_user_outlined, { type: "user" })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_input_password, {
          value: _ctx.logezyPassword,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.logezyPassword) = $event)),
          size: "large",
          placeholder: "Password",
          type: "password",
          "allow-clear": "",
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [
            _createVNode(_component_LockOutlined)
          ]),
          _: 1
        }, 8, ["value"]),
        _withDirectives(_createVNode(_component_a_select, {
          value: _ctx.logezyAddressId,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.logezyAddressId) = $event)),
          placeholder: "Select Agency",
          "show-search": "",
          "filter-option": _ctx.filterOption,
          onChange: _ctx.onlogezyAddressChanged,
          allowClear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userTenants, (userTenant) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                value: userTenant.id,
                key: userTenant.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(userTenant.organization_name) + " - " + _toDisplayString(userTenant.address), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "filter-option", "onChange"]), [
          [_vShow, _ctx.userTenants.length>0]
        ]),
        (_ctx.emailModalError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          size: "large",
          block: "",
          class: "login-btn",
          loading: _ctx.addressLoading,
          onClick: _ctx.fetchTenants
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}